import { render, staticRenderFns } from "./LicensingTable.vue?vue&type=template&id=7c9267da&scoped=true&"
import script from "./LicensingTable.vue?vue&type=script&lang=js&"
export * from "./LicensingTable.vue?vue&type=script&lang=js&"
import style0 from "./LicensingTable.vue?vue&type=style&index=0&id=7c9267da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9267da",
  null
  
)

export default component.exports